var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 33,
    viewBox: "0 0 98 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.782593,
    width: 2,
    height: 14.2391,
    rx: 1,
    fill: "#282828",
    fillOpacity: 0.28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0.782593,
    width: 2,
    height: 14.2391,
    rx: 1,
    fill: "#282828",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 0.782593,
    width: 2,
    height: 14.2391,
    rx: 1,
    fill: "#282828",
    fillOpacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 0.782593,
    width: 2,
    height: 31.3261,
    rx: 1,
    fill: "#D16564"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 0.782593,
    width: 2,
    height: 14.2391,
    rx: 1,
    fill: "#282828"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0.782593,
    width: 2,
    height: 14.2391,
    rx: 1,
    fill: "#282828"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 0.782593,
    width: 2,
    height: 14.2391,
    rx: 1,
    fill: "#282828"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 0.782593,
    width: 2,
    height: 14.2391,
    rx: 1,
    fill: "#282828",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 0.782593,
    width: 2,
    height: 14.2391,
    rx: 1,
    fill: "#282828",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.a97632fdd00d2e10e6eaf3fa08260d23.svg";
export { ForwardRef as ReactComponent };